/* sm-litpunktar.js - smellur á lita- eða efnispunkt skiptir um mynd kortsins og beinir tenglinum á það afbrigði.
   Einn hlustari á skjalinu, svo hann lifir af endurteikningu kafla í þemaritlinum. */
(function () {
  function sott(g) {
    if (g.hasAttribute("data-sott")) return;
    g.setAttribute("data-sott", "");
    g.querySelectorAll("[data-src]").forEach(function (b) { new Image().src = b.getAttribute("data-src"); });
  }
  function velja(d) {
    var k = d.closest("[data-sm-kort]"); if (!k) return;
    var img = k.querySelector("[data-sm-kort-mynd] img"), a = k.querySelector("[data-sm-kort-link]"), val = k.querySelector("[data-sm-kort-val]");
    var src = d.getAttribute("data-src"), href = d.getAttribute("data-href");
    if (img && src) {
      img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = src; img.alt = d.getAttribute("data-alt") || img.alt;
      /* lifandi kortamyndir hafa sitt eigið hlutfall (data-b/data-h) */
      var b = d.getAttribute("data-b"), h = d.getAttribute("data-h");
      if (b && h) { img.setAttribute("width", b); img.setAttribute("height", h); img.classList.toggle("is-breid", b / h > 2.6); }
    }
    if (a && href) a.href = href;
    if (val) val.textContent = d.getAttribute("aria-label");
    k.querySelectorAll(".sm-litir .or-litdot").forEach(function (x) {
      var on = x === d; x.classList.toggle("active", on); x.setAttribute("aria-pressed", String(on)); x.tabIndex = on ? 0 : -1;
    });
  }
  document.addEventListener("pointerover", function (e) { var g = e.target.closest && e.target.closest(".sm-litir"); if (g) sott(g); });
  document.addEventListener("focusin", function (e) { var g = e.target.closest && e.target.closest(".sm-litir"); if (g) sott(g); });
  document.addEventListener("click", function (e) {
    var d = e.target.closest && e.target.closest(".sm-litir .or-litdot"); if (!d) return;
    e.preventDefault(); velja(d);
  });
  /* Örvalyklar færa á milli punkta innan korts, svo hvert kort kostar bara tvö tab-stopp */
  document.addEventListener("keydown", function (e) {
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    var d = e.target.closest && e.target.closest(".sm-litir .or-litdot"); if (!d) return;
    var allir = Array.prototype.slice.call(d.closest(".sm-litir").querySelectorAll(".or-litdot")), i = allir.indexOf(d), n = allir.length, j = -1;
    if (e.key === "ArrowRight" || e.key === "ArrowDown") j = (i + 1) % n;
    else if (e.key === "ArrowLeft" || e.key === "ArrowUp") j = (i - 1 + n) % n;
    else if (e.key === "Home") j = 0;
    else if (e.key === "End") j = n - 1;
    if (j < 0) return;
    e.preventDefault(); allir[j].focus(); velja(allir[j]);
  });
  /* Hver hópur þarf eitt tab-stopp, líka ef enginn punktur var merktur virkur.
     Tengill kortsins vísar líka á litinn sem kortið sýnir, annars opnar varan sinn eigin sjálfgefna lit. */
  function tryggja() {
    document.querySelectorAll(".sm-litir").forEach(function (g) {
      if (!g.querySelector('.or-litdot[tabindex="0"]')) { var f = g.querySelector(".or-litdot"); if (f) f.tabIndex = 0; }
      var on = g.querySelector(".or-litdot.active"), k = g.closest("[data-sm-kort]"), a = k && k.querySelector("[data-sm-kort-link]");
      if (on && a && on.getAttribute("data-href") && a.href.indexOf("variant=") < 0) a.href = on.getAttribute("data-href");
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tryggja); else tryggja();
  document.addEventListener("shopify:section:load", tryggja);
})();
